import React, { useState } from "react";
import Editor from "@monaco-editor/react";
import Heading from "../../component-lib/Atoms/heading/EventEHRHeading";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import Button from "../../component-lib/Molecules/button/Button";
import Table from "../../component-lib/Organisms/table/EventEHRTable";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Card,
  CardContent,
  Box,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Input from "../../component-lib/Atoms/Input/Input";
import axios from "axios";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { useDispatch } from "react-redux";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const ApiDocumentation = () => {
  const myStyle = { fontWeight: "bold", fontSize: "20px" };
  const myObject = {
    participants: [
      {
        bsaId: "123456789",
        firstName: "John",
        lastName: "Doe",
        dateOfBirth: "1999-01-21",
        contactNumber: "8888888888",
        profileId: "PROF98765",
        participantType: "any",
        registrationId: "REG54321",
        groupId: "GRP112233",
        email: "john.doe@example.com",
        gender: "Male",
        emergencyContact: {
          contactName: "Jane Doe",
          contactRelation: "Mother",
          contactEmail: "jane.doe@example.com",
          contactNumber: "8888888888",
        },
        unitLeader: {
          name: "Mike Johnson",
          unitNumber: "Troop 101",
          leaderName: "Mike Johnson",
          email: "mike.johnson@example.com",
          leaderContact: "9999999999",
        },
      },
    ],
  };

  const dispatch = useDispatch();
  const [response, setResponse] = useState<any>({});

  const [formData, setFormData] = useState({
    xAPIKey: "06e37199-fe39-8056-d07f-c137ac1dedc5",
    code: JSON.stringify(myObject, null, 2),
  });
  const copyText = async () => {
    try {
      const text = "06e37199-fe39-8056-d07f-c137ac1dedc5";
      await navigator.clipboard.writeText(text);
      eventEHRCustomToastMessage({
        title: `Copied`,
        status: "success",
      });
    } catch (err) {
      eventEHRCustomToastMessage({
        title: `Failed to copy!`,
        status: "success",
      });
    }
  };

  const copyDeleteText = async () => {
    try {
      const text = "06e37199-fe39-8056-d07f-c137ac1dedc5";
      await navigator.clipboard.writeText(text);
      eventEHRCustomToastMessage({
        title: `Copied`,
        status: "success",
      });
    } catch (err) {
      eventEHRCustomToastMessage({
        title: `Failed to copy!`,
        status: "success",
      });
    }
  };

  const columnData = [
    {
      field: "keyName",
      label: <div>Key Name</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal common-text-ellipse-style">
          {row?.key}
        </p>
      ),
    },
    {
      field: "description",
      label: <div>Description</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.description}</p>
      ),
    },
    {
      field: "isOptional",
      label: <div>Is Optional</div>,
      renderLogic: (row: any) => (
        <p className="text-neutral-90 font-normal">{row?.isOptional}</p>
      ),
    },
  ];

  const rowData = [
    {
      key: "bsaId",
      name: "BSA ID",
      description: "Unique identifier for the participant.",
      isOptional: "false",
    },
    {
      key: "firstName",
      name: "First Name",
      description: "Participant's first name.",
      isOptional: "false",
    },
    {
      key: "lastName",
      name: "Last Name",
      description: "Participant's last name.",
      isOptional: "false",
    },
    {
      key: "dateOfBirth",
      name: "Date of Birth",
      description: "Participant's date of birth in YYYY-MM-DD format.",
      isOptional: "false",
    },
    {
      key: "contactNumber",
      name: "Contact Number",
      description: "Participant's primary contact number.",
      isOptional: "false",
    },
    {
      key: "profileId",
      name: "Profile ID",
      description: "Unique identifier for the participant's profile.",
      isOptional: "false",
    },
    {
      key: "participantType",
      name: "Participant Type",
      description: "Participant Type",
      isOptional: "false",
    },
    {
      key: "registrationId",
      name: "Registration ID",
      description: "Identifier for the participant's registration.",
      isOptional: "false",
    },
    {
      key: "groupId",
      name: "Group ID",
      description: "Identifier for the participant's assigned group.",
      isOptional: "false",
    },
    {
      key: "email",
      name: "Email",
      description: "Participant's email address.",
      isOptional: "false",
    },
    {
      key: "gender",
      name: "Gender",
      description: "Participant's gender (e.g., Male, Female, Other).",
      isOptional: "false",
    },
    {
      key: "contactName",
      name: "Emergency Contact Name",
      description: "Name of the participant's emergency contact person.",
      isOptional: "false",
    },
    {
      key: "contactRelation",
      name: "Emergency Contact Relation",
      description: "Relationship of the emergency contact to the participant.",
      isOptional: "false",
    },
    {
      key: "contactEmail",
      name: "Emergency Contact Email",
      description: "Email of the emergency contact.",
      isOptional: "false",
    },
    {
      key: "contactNumber",
      name: "Emergency Contact Number",
      description: "Phone number of the emergency contact.",
      isOptional: "false",
    },
    {
      key: "name",
      name: "Unit Leader Name",
      description: "Name of the unit leader.",
      isOptional: "false",
    },
    {
      key: "unitNumber",
      name: "Unit Number",
      description: "Identifier for the participant's unit.",
      isOptional: "false",
    },
    {
      key: "leaderName",
      name: "Unit Leader Name",
      description: "Name of the participant's unit leader.",
      isOptional: "false",
    },
    {
      key: "email",
      name: "Unit Leader Email",
      description: "Email address of the unit leader.",
      isOptional: "false",
    },
    {
      key: "leaderContact",
      name: "Unit Leader Contact Number",
      description: "Phone number of the unit leader.",
      isOptional: "false",
    },
  ];

  const handleEditorChange = (newValue: string | undefined) => {
    setFormData((prevData: any) => ({ ...prevData, code: newValue }));
  };

  const postData = async (formData: any) => {
    dispatch(showLoader());

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/participant`,
        formData?.code, // Request body
        {
          headers: {
            "x-api-key": formData?.xAPIKey,
            "Content-Type": "application/json",
          },
        }
      );
      setResponse(response);
      eventEHRCustomToastMessage({
        title: `${response?.data?.message}`,
        status: "success",
      });
      hideLoader();
    } catch (error: any) {
      setResponse(error);
      console.error("Error:", error);
      eventEHRCustomToastMessage({
        title: `${error?.response?.data?.message}`,
        status: "error",
      });
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "60% 40%",
        background: "white",
      }}
    >
      <div
        className="p-4 font-medium
"
      >
        <h1 className="text-[30px]">API Documentation</h1>

        <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap", mb: 3 }}>
          {/* POST Method Card */}
          <Card sx={{ minWidth: 300, maxWidth: 500, flex: 1 }}>
            <CardContent>
              <Typography variant="h6" color="primary" gutterBottom>
                ADD Participant
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  API Endpoint:
                </Typography>
                <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                  {`${process.env.REACT_APP_API_URL}/participant`}
                </Typography>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Method:
                </Typography>
                <Typography variant="body2">POST</Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography variant="subtitle1" gutterBottom>
                Authorization
              </Typography>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
              >
                <Typography variant="body2">x-api-key:</Typography>
                <Button
                  variant="contained"
                  // size="small"
                  startIcon={<ContentCopyIcon />}
                  onClickCb={copyText}
                >
                  Copy
                </Button>
              </Box>
            </CardContent>
          </Card>

          {/* DELETE Method Card */}
          <Card sx={{ minWidth: 300, maxWidth: 500, flex: 1 }}>
            <CardContent>
              <Typography variant="h6" color="error" gutterBottom>
                DELETE Participant
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  API Endpoint:
                </Typography>
                <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
                  {`${process.env.REACT_APP_API_URL}/participant/{bsaId}`}
                </Typography>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Method:
                </Typography>
                <Typography variant="body2">DELETE</Typography>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Typography variant="subtitle1" gutterBottom>
                Authorization
              </Typography>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
              >
                <Typography variant="body2">x-api-key:</Typography>
                <Button
                  variant="contained"
                  // size="small"
                  startIcon={<ContentCopyIcon />}
                  onClickCb={copyDeleteText}
                >
                  Copy
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>

        <div>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography
                component="span"
                className="font-medium text-[20px]
"
                sx={myStyle}
              >
                Security
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <h1>http</h1>
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography sx={myStyle} component="span">
                Headers
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <h1>Authorization</h1>
              <span className="font-normal">String</span>
              <div className="my-3">
                <hr />
              </div>
              <h1>Content-Type</h1>
              <span className="font-normal">String</span>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography sx={myStyle} component="span">
                Body
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <h1>Media type: application/json</h1>
            </AccordionDetails>
          </Accordion>
        </div>

        <div className="pt-3">
          <Editor
            theme="vs-dark" // Dark theme
            height="600px"
            // width={"50%"}
            defaultLanguage="json"
            defaultValue={JSON.stringify(myObject, null, 2)}
            options={{
              readOnly: true, // Prevent editing
              minimap: { enabled: true }, // Hide minimap
              scrollBeyondLastLine: false, // Prevent unnecessary scrolling
              wordWrap: "on", // Wrap text instead of horizontal scrolling
              overviewRulerLanes: 0, // Remove right-side scrollbar
              scrollbar: {
                // vertical: "hidden",
                // horizontal: "hidden",
              },
            }}
          />
        </div>
        <div className="pt-3">
          <Heading title="Fields Information" />
        </div>
        <div className="pt-3">
          <Table columns={columnData} rows={rowData} />
        </div>
      </div>
      <div className="mt-[25%] flex flex-col gap-3">
        <div>
          <Heading title="Header" customStyle={{ marginBottom: "10px" }} />
          <Input
            type="password"
            textFieldLabel="X-API-KEY"
            name={"xAPIKey"}
            disabled={true}
            value={formData?.xAPIKey}
            onChangeCb={(e) => {
              setFormData((prevData: any) => ({
                ...prevData,
                xAPIKey: e.target?.value,
              }));
            }}
            size="small"
          />
        </div>

        <div className="pt-3">
          <Heading title="Body" />
          <Editor
            theme="vs-dark" // Dark theme
            height="400px"
            // width={"50%"}
            defaultLanguage="json"
            value={formData?.code}
            onChange={handleEditorChange} // Capture changes
            options={{
              minimap: { enabled: true }, // Hide minimap
              scrollBeyondLastLine: false, // Prevent unnecessary scrolling
              wordWrap: "on", // Wrap text instead of horizontal scrolling
              overviewRulerLanes: 0, // Remove right-side scrollbar
              scrollbar: {
                // vertical: "hidden",
                // horizontal: "hidden",
              },
            }}
          />
        </div>
        <div className="pt-3">
          <Button
            label="Send"
            onClickCb={() => {
              postData(formData);
            }}
            variant={"contained"}
          />
        </div>

        {response?.status && (
          <div className="pt-3">
            <Heading title="Output" />
            <div>Status code: {response?.status}</div>

            <Editor
              theme="vs-dark" // Dark theme
              height="400px"
              // width={"50%"}
              defaultLanguage="json"
              value={response?.data?.message}
              // onChange={handleEditorChange} // Capture changes
              options={{
                readOnly: true, // Prevent editing
                minimap: { enabled: true }, // Hide minimap
                scrollBeyondLastLine: false, // Prevent unnecessary scrolling
                wordWrap: "on", // Wrap text instead of horizontal scrolling
                overviewRulerLanes: 0, // Remove right-side scrollbar
                scrollbar: {
                  // vertical: "hidden",
                  // horizontal: "hidden",
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ApiDocumentation;
